mama-tabs {
  display: block;

  &.bg-theme {
    mama-tab-content {
      background-color: var(--theme-color-light, $mm-petrol-10);
    }

    .prominent-large {
      background: transparent;
      box-shadow: 0 0 5px var(--theme-color, $mm-petrol);

      .right {
        padding-left: 10px;
      }
    }
  }
}

mama-tab-content {
  display: none;
  padding: 1rem;
  margin-top: 1rem;
  border: 2px solid var(--theme-color-light, $mm-petrol-10);
  border-radius: 1rem;

  @include media-breakpoint-up(md) {
    padding: 2rem;
  }

  &.active {
    display: block;
  }

  :last-child {
    margin-bottom: 0;
  }

  .static-text {
    p {
      margin-bottom: 1rem;
    }
  }

  mama-accordion {
    &,
    &:last-child {
      margin-top: -1rem;
      margin-bottom: -1rem;

      @include media-breakpoint-up(md) {
        margin-top: -2rem;
        margin-bottom: -2rem;
      }
    }
  }
}

.tabs-header {
  .form-group {
    margin-bottom: 0;
    padding-top: 0;

    .mobile-select .select {
      .head {
        border: 2px solid var(--theme-color-light, $mm-petrol-10);
        border-radius: 0.75rem;
        background: transparent;
      }

      span.option {
        font-weight: normal;
      }

      button {
        right: 8px;
        top: 6px;
        background-color: transparent;
      }
    }

    .select {
      .head {
        @include media-breakpoint-up(lg) {
          display: none;
        }
      }

      > .visible,
      > .hidden {
        @include media-breakpoint-up(lg) {
          display: block !important;
          position: relative;
        }
      }

      .body {
        @include media-breakpoint-up(lg) {
          display: flex;
          border: 0;
          padding: 0;
          position: relative;
        }

        .option {
          min-height: 56px;
          align-self: center;
          width: auto;
          padding: 1rem 1.5rem;
          font-size: $font-size-s;
          font-weight: $font-weight-bolder;
          color: var(--theme-body-color, $mm-black-blue);
          border-radius: 28px;
          margin-right: 1rem;
          border: 0;
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }

          &:hover,
          &.active {
            color: var(--theme-color-active, $mm-petrol-pressed);
            background-color: var(--theme-color-light, $mm-petrol-10);
          }
        }
      }
    }
  }
}
